export default __webpack_public_path__ + "static/media/line_shape.1c36b4b5.svg";